module.exports = __webpack_public_path__ + "img/744.fff0f276.jpg";